<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card p-3">
      <div class="card-body">
        <h2 class="card-title-desc">Record Shipment</h2>
        <shipment-form button_text="Add Shipment" @shipmentAction="recordShipment"/>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import ShipmentForm from "@/components/shipment/shipment-form";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import {routeItems} from "@/router/endpoints";

export default {
  page: {
    title: "Record Shipment",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {ShipmentForm, PageHeader, Layout},
  name: "record-shipment",
  data() {
    return {
      title: "Record Shipment",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Record Shipment",
          active: true
        }
      ],
    }
  },
  methods: {
    ... mapActions({
      addShipmentFn: 'stock/addNewShipment',
    }),
    async recordShipment(data){
      await this.addShipmentFn(data).then(resp => {
        if(resp.publicId){
          successToast(`New Shipment added successfully`)
          this.$router.push(routeItems.shipments_route)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
